const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}



/* ===== BEFORE / AFTER SLIDER (DRAG ONLY ON HANDLE) ===== */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".before-after-wrapper").forEach((wrapper) => {

    if (wrapper.dataset.beforeAfterInit === "1") return;
    wrapper.dataset.beforeAfterInit = "1";

    const beforeWrapper = wrapper.querySelector(".before-image-wrapper");
    const slider = wrapper.querySelector(".slider-handle");
    if (!beforeWrapper || !slider) return;

    // posição inicial
    beforeWrapper.style.width = "50%";
    slider.style.left = "50%";

    let dragging = false;

    const move = (clientX) => {
      const rect = wrapper.getBoundingClientRect();
      let percent = ((clientX - rect.left) / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));

      beforeWrapper.style.width = percent + "%";
      slider.style.left = percent + "%";
    };

    /* DRAG SOMENTE NO HANDLE */
    slider.addEventListener("pointerdown", (e) => {
      dragging = true;
      slider.setPointerCapture(e.pointerId);
    });

    slider.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      move(e.clientX);
    });

    const stop = () => {
      dragging = false;
    };

    slider.addEventListener("pointerup", stop);
    slider.addEventListener("pointercancel", stop);
    slider.addEventListener("pointerleave", stop);

  });
});




/* ===== CAROUSEL SWIPE (mary jane) ===== */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".carousel-container").forEach((carousel) => {
    if (carousel.dataset.carouselInit === "1") return;
    carousel.dataset.carouselInit = "1";

    const track = carousel.querySelector(".carousel-track");
    const slides = carousel.querySelectorAll(".carousel-slide");
    const dots = carousel.querySelectorAll(".dot");
    if (!track || slides.length === 0) return;

    let index = 0;
    let slideWidth = carousel.offsetWidth;

    let isPointerDown = false;
    let isDragging = false;
    let startX = 0, startY = 0;
    let lastX = 0;
    let rafId = null;

    const updateDots = () => {
      if (!dots.length) return;
      dots.forEach((d) => d.classList.remove("active"));
      if (dots[index]) dots[index].classList.add("active");
    };

    const setTransform = (x, animate = true) => {
      track.style.transition = animate ? "transform 0.35s ease" : "none";
      track.style.transform = `translateX(${x}px)`;
    };

    const goTo = (i, animate = true) => {
      index = Math.max(0, Math.min(slides.length - 1, i));
      setTransform(-index * slideWidth, animate);
      updateDots();
    };

    const recalc = () => {
      slideWidth = carousel.offsetWidth;
      goTo(index, false);
    };

    window.addEventListener("resize", recalc);

    // Dots click
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => goTo(i, true));
    });

    const applyDrag = () => {
      rafId = null;
      const dx = lastX - startX;
      setTransform(dx - index * slideWidth, false);
    };

    const queueDrag = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(applyDrag);
    };

    // Pointer events (touch + mouse)
    track.addEventListener("pointerdown", (e) => {
      isPointerDown = true;
      isDragging = false;  // só vira drag se for horizontal
      startX = e.clientX;
      startY = e.clientY;
      lastX = e.clientX;
      track.style.transition = "none";
    });

    track.addEventListener("pointermove", (e) => {
      if (!isPointerDown) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      // ✅ Só ativa swipe se for horizontal (não trava rolagem)
      if (!isDragging) {
        if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
          isDragging = true;
          track.setPointerCapture(e.pointerId);
        } else {
          return; // deixa a página rolar
        }
      }

      lastX = e.clientX;
      queueDrag();
    });

    const end = () => {
      if (!isPointerDown) return;
      isPointerDown = false;

      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;

      if (!isDragging) {
        // toque rápido sem arrastar: não faz nada (mantém rolagem natural)
        goTo(index, true);
        return;
      }

      const diff = lastX - startX;

      if (diff < -50 && index < slides.length - 1) index++;
      if (diff > 50 && index > 0) index--;

      goTo(index, true);
      isDragging = false;
    };

    track.addEventListener("pointerup", end);
    track.addEventListener("pointercancel", end);
    track.addEventListener("pointerleave", end);

    // iniciar
    goTo(0, false);
  });
});



/* ===== ACORDEÃO (mary jane) ===== */
(function () {
  function initCdAccordions(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-cd-accordion]').forEach(function (wrap) {
      if (wrap.dataset.cdReady === "true") return;
      wrap.dataset.cdReady = "true";

      wrap.querySelectorAll('.cd-acc-item').forEach(function (item) {
        var header = item.querySelector('.cd-acc-header');
        var icon = item.querySelector('.cd-acc-icon');

        if (!header || !icon) return;

        function setOpen(open) {
          item.classList.toggle('is-open', open);
          header.setAttribute('aria-expanded', open ? 'true' : 'false');
          icon.textContent = open ? '−' : '+';
        }

        // começa fechado sempre
        setOpen(false);

        function toggle() {
          setOpen(!item.classList.contains('is-open'));
        }

        header.addEventListener('click', toggle);
        header.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCdAccordions(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCdAccordions(event.target || document);
  });
})();


 /* CD | ENTREGA ESTIMADA | 3 A 5 DÍAS HÁBILES | COLOMBIA */

(function () {

  // Feriados nacionais Colômbia 2026
  var CO_HOLIDAYS_2026 = new Set([
    "2026-01-01","2026-01-12","2026-03-23","2026-04-02","2026-04-03",
    "2026-05-01","2026-05-18","2026-06-08","2026-06-15","2026-06-29",
    "2026-07-20","2026-08-07","2026-08-17","2026-10-12","2026-11-02",
    "2026-11-16","2026-12-08","2026-12-25"
  ]);

  function pad(n){ return String(n).padStart(2,"0"); }

  function format(d){
    return pad(d.getDate())+"/"+pad(d.getMonth()+1)+"/"+d.getFullYear();
  }

  function iso(d){
    return d.getFullYear()+"-"+pad(d.getMonth()+1)+"-"+pad(d.getDate());
  }

  function todayBogota(){
    var parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: "America/Bogota",
      year: "numeric", month: "2-digit", day: "2-digit"
    }).formatToParts(new Date());

    var y,m,d;
    parts.forEach(p=>{
      if(p.type==="year") y=p.value;
      if(p.type==="month") m=p.value;
      if(p.type==="day") d=p.value;
    });
    return new Date(y, m-1, d);
  }

  function isSunday(d){ return d.getDay() === 0; }

  function isHoliday(d){
    return d.getFullYear() === 2026 && CO_HOLIDAYS_2026.has(iso(d));
  }

  function addBusinessDays(start, days){
    var d = new Date(start);
    var added = 0;
    while(added < days){
      d.setDate(d.getDate()+1);
      if(isSunday(d)) continue;
      if(isHoliday(d)) continue;
      added++;
    }
    return d;
  }

  function init(root){
    var blocks = (root || document).querySelectorAll("[data-cd-delivery-range]");
    blocks.forEach(function(el){
      if(el.dataset.ready) return;
      el.dataset.ready = "true";

      var min = parseInt(el.dataset.min,10);
      var max = parseInt(el.dataset.max,10);

      var today = todayBogota();
      var from = addBusinessDays(today, min);
      var to   = addBusinessDays(today, max);

      el.querySelector(".cd-delivery-from").textContent = format(from);
      el.querySelector(".cd-delivery-to").textContent   = format(to);
    });
  }

  document.addEventListener("DOMContentLoaded", ()=>init(document));
  document.addEventListener("shopify:section:load", e=>init(e.target));

})();



/* CD | BARRA ESTOQUE | JS (MANUAL) */
(function(){
  function cdInitStockBars(){
    document.querySelectorAll(".cd-stockbar").forEach(function(el){
      var pct = parseInt(el.getAttribute("data-cd-stock-percent") || "0", 10);
      if (isNaN(pct)) pct = 0;
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;

      var fill = el.querySelector(".cd-stockbar__fill");
      if(fill) fill.style.width = pct + "%";

      // opcional: manter número sincronizado
      var num = el.getAttribute("data-cd-stock-number");
      var qty = el.querySelector(".cd-stockbar__qty");
      if(qty && num) qty.textContent = num;
    });
  }

  document.addEventListener("DOMContentLoaded", cdInitStockBars);
  document.addEventListener("shopify:section:load", cdInitStockBars);
})();

